<template>
  <entity-dashboard-view></entity-dashboard-view>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations";
import EntityDashboardView from "@/client/views/admin/entity/EntityDashboard.vue";
export default {
  components: { EntityDashboardView },
  layout: "adminDashboard",

  middleware: {
    requireSuperAdmin: {},
  },
  props: {},
  setup(props) {
    let { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations(props);
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  meta: "admin.entity.pageTitle",
  data: function () {
    return {

    };
  },
  computed: {},
  methods: {},
};
</script>
